import { browserSupportsWebAuthn, startRegistration, startAuthentication } from '@simplewebauthn/browser'
import axios from '@/services/axios'

const passkeyService = {
  isSupported() {
    return browserSupportsWebAuthn()
  },

  async register(credentialName = 'My Passkey') {
    // 1. Get registration options from server
    const { data: options } = await axios.post('/auth/passkey/register/options')

    // 2. Create credential via browser API
    const attResp = await startRegistration({ optionsJSON: options })

    // 3. Send back to server for verification
    const { data: result } = await axios.post('/auth/passkey/register/verify', {
      ...attResp,
      credential_name: credentialName
    })

    return result
  },

  async authenticate(email = null) {
    // 1. Get authentication options
    const { data: options } = await axios.post('/auth/passkey/login/options', { email })

    const { sessionId, ...authOptions } = options

    // 2. Authenticate via browser API
    const authResp = await startAuthentication({ optionsJSON: authOptions })

    // 3. Send back to server for verification
    const { data: result } = await axios.post('/auth/passkey/login/verify', {
      ...authResp,
      sessionId,
      email
    })

    return result
  },

  async getCredentials() {
    const { data } = await axios.get('/auth/passkey/credentials')
    return data.credentials
  },

  async deleteCredential(id) {
    const { data } = await axios.delete(`/auth/passkey/credentials/${id}`)
    return data
  },

  async renameCredential(id, credential_name) {
    const { data } = await axios.patch(`/auth/passkey/credentials/${id}`, { credential_name })
    return data
  }
}

export default passkeyService
